// app企微引流到小程序中转页面
<template>
  <div class="main">若未自动跳转，请点击<a @click="redirect">这里</a></div>
</template>

<script>
import { getUserByCredentials, getQWCode } from '@/apis/gameJump';

export default {
  data() {
    return {
      wxQrCode: '',
      user_id: ''
    };
  },
  async mounted() {
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      const { credential, appkey } = this.$route.query;
      try {
        const r = await getUserByCredentials({ 
          credential,
          appkey,
        });
        if (r.ret == 1) {
          this.user_id = r.content.user_id;
          localStorage.setItem('lead_user_id', r.content.user_id);
        } else {
          this.user_id = localStorage.getItem('lead_user_id');
        }
        this.redirect()
      } catch (error) {
        this.user_id = localStorage.getItem('lead_user_id');
        this.redirect()
      }
    },
    redirect() {
      const appid = 'wx7ebd52bd136e97d9';
      let data = encodeURIComponent(`user_id=${this.user_id}&appkey=${this.$route.query.appkey}&banner_id=${this.$route.query.banner_id}`);
      const ENV_VERSION = 'release'; // 正式版为release，体验版为trial，开发版为develop
      console.log('data', data);
      console.log('ENV_VERSION', ENV_VERSION);
      console.log(`weixin://dl/business/?appid=${appid}&path=pages/index/index&query=${data}&env_version=${ENV_VERSION}`);
      window.location.href = `weixin://dl/business/?appid=${appid}&path=pages/index/index&query=${data}&env_version=${ENV_VERSION}`
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  height: 100%;
  position: relative;
  .wxQrCode {
    position: absolute;
    bottom: 70px;
    right: 40px;
    width: 150px;
    height: 150px;
  }
}
</style>